import { render, staticRenderFns } from "./RptAllDevActTot.vue?vue&type=template&id=126d4c6a"
import script from "./RptAllDevActTot.vue?vue&type=script&lang=js"
export * from "./RptAllDevActTot.vue?vue&type=script&lang=js"
import style0 from "./RptAllDevActTot.vue?vue&type=style&index=0&id=126d4c6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports